import {db} from 'src/db/db';
const config = require("src/config.json");
const axios = require('axios').default;

const isNewUser = async (user) => {
    //Get User Data from Firestore.
    const userSnap = await db.collection("users").doc(user.uid).get();
    return !userSnap.exists;
};

const sendNewMusicianAPI = async (musicianName, email, uid) => {

    //Get Stage API endpoint.
    const endpoint = getNewMusicianApiEndpoint();

    //Send API.
    const response = await axios.post(endpoint, {
      musicianName,
      email,
      uid
    })
    return response;
}

const getNewMusicianApiEndpoint = () => {
  //1. Get URL to determine environment.
  let url = window.location.href.split("/")[2].split('.')[0];
  //2. Get environment.
  const environment = (url === config['production'].websitePath ? "production" : (url === config['test'].websitePath ? "test" : "dev"));
  //3. Get endpoint from config[environment].
  const endpoint = config[environment].newMusicianApi.endpoint;
  return endpoint;
}

export {
  isNewUser,
  sendNewMusicianAPI
};